export const SEARCH_PAGE_SIZE = 100;
